import React from 'react';
import ConnectionIndicator from '../../../connection-indicator/components/web/ConnectionIndicator';
import { makeStyles } from 'tss-react/mui';
import { useMediaQuery } from '@mui/material';
const useStyles = makeStyles()(theme => {
    return {
        moreStatsContainer: {
            '& .jitsi-icon.jitsi-icon-default': {
                backgroundColor: 'transparent'
            },
        }
    };
});
const MoreStatsParticipant = ({ participantId }) => {
    const { classes } = useStyles();
    const isMobile = useMediaQuery('(max-width:1024px)');
    const postition = isMobile ? 'left-start' : 'right-start';
    return (React.createElement("div", { className: classes.moreStatsContainer },
        React.createElement(ConnectionIndicator, { alwaysVisible: true, enableStatsDisplay: true, participantId: participantId, isStats: true, statsPopoverPosition: postition })));
};
export default MoreStatsParticipant;
